<template>
  <click-to-edit
    v-model="scope.row.scale.fact"
    :number-format="{decimals: 6, space:true}"
    :disabled="!isFieldAvailableForEdit(scope.row, 'scale.fact')"
    placeholder=""
    @input="saveElementPropChange(scope.row, 'scale', {fact:$event})"
  >
  </click-to-edit>
</template>

<script>


import ClickToEdit from "@/components/ClickToEdit.vue";
import {ElementPropTableColumn} from "@/mixins/elementPropTableColumn";

export default {
  name: 'element-fact-table-column',
  components: {ClickToEdit},
  mixins: [ElementPropTableColumn],

  props: {},
  data() {
    return {

    }
  },

  methods: {

  }
}

</script>

<style>

</style>
